import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["props", "preserveValue", "support", "valueDestructuring"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

export function fieldsToValue(fields) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$useValueDestruct = _ref.useValueDestructuring,
      useValueDestructuring = _ref$useValueDestruct === void 0 ? true : _ref$useValueDestruct;

  return fields.reduce(function (total, _ref2) {
    var _ref3, _state$visible;

    var name = _ref2.name,
        _ref2$config = _ref2.config,
        fixedProps = _ref2$config.props,
        _ref2$config$preserve = _ref2$config.preserveValue,
        preserveValue = _ref2$config$preserve === void 0 ? false : _ref2$config$preserve,
        support = _ref2$config.support,
        valueDestructuring = _ref2$config.valueDestructuring,
        otherConfig = _objectWithoutProperties(_ref2$config, _excluded),
        _ref2$state = _ref2.state,
        state = _ref2$state === void 0 ? {} : _ref2$state;

    var visible = (_ref3 = (_state$visible = state === null || state === void 0 ? void 0 : state.visible) !== null && _state$visible !== void 0 ? _state$visible : otherConfig === null || otherConfig === void 0 ? void 0 : otherConfig.visible) !== null && _ref3 !== void 0 ? _ref3 : true; // 如果不可见，或者是支援字段，不收录这条数据

    if (!visible && !preserveValue || support) {
      return total;
    }

    var props = _objectSpread(_objectSpread({}, fixedProps), state.props);

    if (valueDestructuring && useValueDestructuring) {
      // 值解构，如果结构失败不返回
      try {
        var destructedValue = valueDestructuring(props.value, props, state, {
          name: name
        });
        return _objectSpread(_objectSpread({}, total), destructedValue);
      } catch (_unused) {
        return total;
      }
    } else {
      return _objectSpread(_objectSpread({}, total), {}, _defineProperty({}, name, props.value));
    }
  }, {});
}
export function fieldsToObject(fields) {
  return fields.reduce(function (total, _ref4) {
    var name = _ref4.name,
        _ref4$config = _ref4.config,
        fixedProps = _ref4$config.props,
        support = _ref4$config.support,
        _ref4$state = _ref4.state,
        state = _ref4$state === void 0 ? {} : _ref4$state;
    return support ? total : _objectSpread(_objectSpread({}, total), {}, _defineProperty({}, name, _objectSpread(_objectSpread({}, fixedProps), state.props)));
  }, {});
}